import React from "react";
import "./PopupLatestReport.scss";
import { generateLatestReport } from "../../api/reportService";
import { toast } from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { fetchDashboardData } from "../../redux/actions/dashboardActions";
import { setIsGeneratingReport } from "../../redux/actions/reportActions";

const PopupLatestReport = ({ report, onClose }) => {
  const dispatch = useDispatch();
  const isGeneratingReport = useSelector(
    (state) => state.report.isGeneratingReport,
  );

  console.log(report);

  const onUpload = async () => {
    console.log(isGeneratingReport);
    if (isGeneratingReport) {
      toast.error("Please wait until the current report is generated", {
        position: "top-center",
        duration: 1500,
      });
      return;
    }
    dispatch(setIsGeneratingReport(true));

    const loadingToastId = toast.loading("Generating report...", {
      position: "top-center",
    });
    try {
      await generateLatestReport(
        report.session_id,
        report.session_lap_idx,
        report.reference_id,
        report.reference_lap_idx,
      );
      toast.dismiss(loadingToastId);
      toast.success("Report generated successfully!", {
        position: "top-center",
        duration: 3000,
      });
      dispatch(fetchDashboardData());
    } catch (error) {
      toast.dismiss(loadingToastId);
      toast.error("Failed to generate report.", {
        position: "top-center",
        duration: 3000,
      });
    }
    dispatch(setIsGeneratingReport(false));
    onClose();
  };

  return (
    <div className="popup">
      <div className="popup-content generate-report popup-latest-report">
        <div className="tit-popup">
          <h2>Generate Latest Report</h2>
        </div>
        <div className="cont-btn btn-popup-latest-reports">
          <button className="btn btn-blue" onClick={onUpload}>Create</button>
          <button className="btn" onClick={onClose} >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default PopupLatestReport;
